import { removeLineBreaks } from "Utils/generalUtils";
import React from "react";
import { JsonToMarkdown } from "../components/Markdown/JsonToMarkdown";

export const renderMarkdownComponent = (text: string): React.ReactElement => {
  if (!isArgumentStringAJsonWithMarkdown(text)) {
    throw new Error(
      "You're attempting to pass a string that does not contain correctly formatted markdown.",
    );
  }

  return <JsonToMarkdown text={text} />;
};

const isArgumentStringAJsonWithMarkdown = (text: string): boolean => {
  try {
    return isJsonContainingValidMarkdown(JSON.parse(removeLineBreaks(text)));
  } catch (e) {
    return false;
  }
};

const isJsonContainingValidMarkdown = (arr: any): boolean => {
  const validHTMLTags = [
    "p",
    "ol",
    "a",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "blockquote",
    "img",
    "hr",
    "code",
    "table",
    "link",
    "ul",
  ];

  return arr.reduce((acc: any, curr: any) => {
    return validHTMLTags.includes(`${Object.keys(curr)}`) ? true : false;
  }, false);
};
